import { Enums } from '@configur-tech/upit-core-types';

export const FORMULA_TYPES = [
  Enums.ValueDataType.DATE_CONVERSION,
  Enums.ValueDataType.FORMULA,
  Enums.ValueDataType.TEXT_TRANSFORMATION,
  Enums.ValueDataType.FIELD_LOOKUP,
];
